import React from 'react';
import PropTypes from 'prop-types';

const BentoCard = ({ 
  children, 
  title, 
  className = "", 
  colSpan = "col-span-1", 
  color = "bg-white", 
  style = {},
  enableHover = true,
  position = "relative" // <--- NEW: Defaults to relative, but can be overridden
}) => {
  
  const hoverEffects = enableHover 
    ? "hover:-translate-y-1 hover:shadow-bento-hover border-primary-navy" 
    : "border-primary-navy";

  return (
    <div 
      className={`
        ${colSpan} 
        ${color} 
        ${position}        
        ${className} 
        rounded-bento 
        border-2           
        shadow-bento       
        p-6 
        transition-all 
        duration-200 
        ease-out
        ${hoverEffects}
      `}
      style={style}
    >
      {title && (
        <h3 className="font-heading text-2xl font-bold mb-4 text-primary-navy">
          {title}
        </h3>
      )}
      <div className="font-body h-full">
        {children}
      </div>
    </div>
  );
};

BentoCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
  colSpan: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  enableHover: PropTypes.bool,
  position: PropTypes.string, // <--- Add to PropTypes
};

export default BentoCard;